import React from "react";
import { withRouter } from "../_shared/withRouter";
import TermsComponent from "../template/_common/termsComponent";

const AdminTerms = () => {
  return <TermsComponent roleType={"admin"} role={"2"} />;
};

export default withRouter(AdminTerms);
